<template>
    <span class="text-danger"><strong>*</strong></span>
</template>
